// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ag-header-cell-label[data-v-c0f6192c] { -webkit-justify-content: center; -ms-flex-pack: center; justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
